import React from 'react';
import TestComponentWrapper from '../widgets/test-component.jsx'; // Assuming TestComponentWrapper is in TestComponent.js

class TestView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false, // You can manage loading state if needed
    };
  }

  // Add any methods you need for handling state or interactions

  render() {
    return (
      <div className="test-view-overlay">
        <div className="test-view-container">
          {/*<h2>Test</h2>*/}
          {/* You can include any additional UI elements here */}
          <TestComponentWrapper 
            onClose={this.props.onCancel} 
            tinode = {this.props.tinode}
            isNeedTest = {this.props.isNeedTest}
            intl = {this.props.intl}
            eventToGAnalitycs = {this.props.eventToGAnalitycs}
          />

          {/* You can also add buttons or other interactive elements if needed */}
        </div>
      </div>
    );
  }
}

export default TestView;
